var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExtendError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 0C12.1022 0 0 12.1022 0 27C0 41.8978 12.1022 54 27 54C41.8978 54 54 41.8978 54 27C54 12.1022 41.8978 0 27 0ZM27 2.34783C40.6289 2.34783 51.6522 13.3711 51.6522 27C51.6522 40.6289 40.6289 51.6522 27 51.6522C13.3711 51.6522 2.34783 40.6289 2.34783 27C2.34783 13.3711 13.3711 2.34783 27 2.34783Z",
    fill: "#FF4040"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4904 38.4905C15.0023 38.0023 14.9913 37.2218 15.4659 36.7472L37.0817 15.1314C37.5563 14.6568 38.3368 14.6678 38.8249 15.1559C39.3131 15.6441 39.3241 16.4246 38.8494 16.8992L17.2337 38.515C16.759 38.9896 15.9786 38.9786 15.4904 38.4905Z",
    fill: "#FF4040"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8249 38.8441C38.3367 39.3323 37.5563 39.3432 37.0816 38.8686L15.4659 17.2528C14.9912 16.7782 15.0022 15.9977 15.4904 15.5096C15.9785 15.0214 16.759 15.0105 17.2336 15.4851L38.8494 37.1008C39.324 37.5755 39.313 38.3559 38.8249 38.8441Z",
    fill: "#FF4040"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtendError);
export default __webpack_public_path__ + "static/media/extendError.193410a07548ac95bb261009cb9a2199.svg";
export { ForwardRef as ReactComponent };